module.exports = __webpack_public_path__ + "static/media/glass-citrus.915d90a6.svg";